import { AppTour } from '../tour.model';

export const MILEAGE_WIZARD_TOUR: AppTour = {

  tourId: 'mileage-wizard-tour',
  showProgress: true,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: false },
  steps: [
    {
      id: 'mileage-wizard-step1-tour',
      attachTo: { element: '#step-guide-1', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_mileage_wizard_step1_title',
      text: 'tour_mileage_wizard_step1_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep1SkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep1SetupClick'}
       ]
     },
     {
      id: 'mileage-wizard-step3-tour',
      attachTo: { element: '#step-guide-3', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_lable_wizard_step3_title',
      text: 'tour_lable_wizard_step3_text',
       buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep2SkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep2SetupClick'}
       ]
     } 
   ]
};

export const SETUP_MILEAGE_RATE_METHOD_PANEL_TOUR: AppTour = {

  tourId: 'setup-mileage-rate-method-panel-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'setup-mileage-rate-method-tour',
      attachTo: { element: '#mileage-rate-calculation-method-guide', on: 'top' },
      cancelIcon: {enabled: false},
      title: 'tour_mileage_setup_rate_method_title',
      text: 'tour_mileage_setup_rate_method_text',
      parallel: true
     }
   ]
};

export const SETUP_MILEAGE_RATE_LIST_TOUR: AppTour = {
  tourId: 'setup-mileage-rate-list-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'setup-mileage-rate-chk-tour',
      attachTo: { element: '.chk-ag-grid-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_mileage_setup_rate_list_title',
      text: 'tour_mileage_setup_rate_list_text',
      parallel: true
     }
   ]
};

export const MANAGE_MILEAGE_RATE_PANEL_TOUR: AppTour = {
  tourId: 'manage-mileage-rate-panel-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'mileage-rate-setting-tour',
      attachTo: { element: '#mileage-rate-setting-guide', on: 'left' },
      cancelIcon: {enabled: false},
      title: 'tour_mileage_manage_rate_title',
      text: 'tour_mileage_manage_rate_text',
      parallel: true
     }
   ]
};